import React, { FC } from 'react';
import classnames from 'classnames';

import { ImageAssetType } from '@skytvnz/sky-app-store/lib/types/enums';
import { getVideoImg } from '@/Utils/VideoImage';
import AdCountdownProgressIcon from '@/Components/Icons';
import getLabel from '@/Utils/LabelsConfig';
import { LABELS_CONFIG } from '@/Hooks/PUJ/constants';
import styles from './styles.module.scss';

export interface Props {
  adCountdown: number;
  adCountdownStart?: number;
  strokeDashOffsetStep: number;
  image: string;
}

const AdCountdownPanel: FC<Props> = ({
  adCountdown = -1,
  adCountdownStart = 0,
  strokeDashOffsetStep = 0,
  image,
}) => {
  const strokeDashOffset = (adCountdownStart - adCountdown) * strokeDashOffsetStep;

  if (adCountdown < 0.3) return <></>;

  return (
    <div className={classnames(styles.adCountdownPanel)} data-testid="adcountdown-container">
      <div className={styles.adCountdownText}>{getLabel(LABELS_CONFIG.VOD_COUNTDOWN_MSG)}</div>
      <div className={styles.adCountdownProgress}>
        <div className={styles.adCountdownIconContainer}>
          <AdCountdownProgressIcon
            className={styles.adCountdownIcon}
            strokeDashOffset={strokeDashOffset}
          />
        </div>
        <div className={styles.adCountdownTime}>{Math.round(adCountdown)}</div>
      </div>
      <div className={styles.adCountdownImage}>
        <img src={getVideoImg(ImageAssetType.ContentTileHorizontal, image)} alt="alt text" />
      </div>
    </div>
  );
};

export default AdCountdownPanel;
